/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum GraphQLFrontCoverState {
  HIDDEN = "HIDDEN",
  SHOWN = "SHOWN",
  UNSET = "UNSET",
}

export interface FaviconFileInput {
  fileStoreId: string;
  filename: string;
}

export interface UpdateSiteLookAndFeelInput {
  backgroundColor?: string | null;
  faviconFiles: FaviconFileInput[];
	showFrontCover?: boolean;
  frontCoverState?: GraphQLFrontCoverState | null;
  highlightColor?: string | null;
  resetFavicon?: boolean | null;
  resetSiteLogo?: boolean | null;
  showSiteName?: boolean | null;
  siteLogoFileStoreId?: string | null;
  siteName?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeHubPublishStateMutation
// ====================================================

export interface ChangeHubPublishStateMutation_updateSiteLookAndFeel_siteLookAndFeel {
  frontCoverState: string | null;
}

export interface ChangeHubPublishStateMutation_updateSiteLookAndFeel_errors_extensions {
  errorType: string | null;
  statusCode: number | null;
}

export interface ChangeHubPublishStateMutation_updateSiteLookAndFeel_errors {
  message: string | null;
  extensions: (ChangeHubPublishStateMutation_updateSiteLookAndFeel_errors_extensions | null)[] | null;
}

export interface ChangeHubPublishStateMutation_updateSiteLookAndFeel {
  siteLookAndFeel: ChangeHubPublishStateMutation_updateSiteLookAndFeel_siteLookAndFeel | null;
  success: boolean;
  errors: ChangeHubPublishStateMutation_updateSiteLookAndFeel_errors[] | null;
}

export interface ChangeHubPublishStateMutation {
  updateSiteLookAndFeel: ChangeHubPublishStateMutation_updateSiteLookAndFeel;
}

export interface ChangeHubPublishStateMutationVariables {
  input: UpdateSiteLookAndFeelInput;
}
